import React, { useEffect } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-white overflow-x-hidden" data-id="element-78">
      <Navbar data-id="element-79" />
      <main className="flex-grow" data-id="element-80">{children}</main>
      <Footer data-id="element-81" />
    </div>;
}